<div class="spinner" [class.override-margins]="!!overrideMargins">
  <zaver-loading-dots [color]="'#b7bcc8'" [diameter]="26"> </zaver-loading-dots>
</div>
